import { html } from 'htm/preact';

const SectionDivider = ({ label = 'or' }) => {
  return html`
    <div
      class="flex lg:flex-col items-center justify-center gap-3 before:w-px before:h-px before:bg-gray-200 before:grow after:h-px after:w-px after:bg-gray-200 after:grow"
    >
      <span class="h6 uppercase"> ${label} </span>
    </div>
  `;
};

export default SectionDivider;
